import swal from "sweetalert";

/**
 * How long auto-dismissing notifications stay on screen before they close themselves.
 */
export const notificationAutoCloseMs = 4000;

/**
 * Notifications that contain details to read (such as a list of failures) stay up longer.
 */
export const notificationDetailAutoCloseMs = 10000;

export interface NotificationOptions {
    title?: string;
    text?: string;
    icon?: string;
    content?: unknown;
}

/**
 * Shows a notification that closes itself after a short delay, so the user does not
 * have to dismiss it. Use {@link confirmAction} when a decision is actually required.
 */
export const notify = (options: NotificationOptions, autoCloseMs: number = notificationAutoCloseMs): Promise<unknown> =>
    swal({ ...options, timer: autoCloseMs } as any);

export const confirmAction = async (title?: string): Promise<boolean> => {
    const result = await swal({
        title: title ?? "Are you sure?",
        icon: "warning",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
    });

    return !!result;
}
